<template>
    <ion-page>
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-menu-button></ion-menu-button>
          </ion-buttons>
          <ion-title>{{ $route.name }}</ion-title>
        </ion-toolbar>
        <ion-toolbar v-if="route.name === 'Chat mensajes'" class="chat-messages-subheader">
          <div class="chat-messages-subheader-inner">
            <ion-button
              size="small"
              :fill="showOnlyUnread ? 'solid' : 'outline'"
              :color="showOnlyUnread ? 'primary' : 'medium'"
              class="chat-filter-header-btn"
              @click="onToggleChatUnreadFilter"
            >
              {{ showOnlyUnread ? 'Ver todos los mensajes' : 'Mostrar sólo no leídos' }}
              <span v-if="!showOnlyUnread && unreadIncomingCount > 0" class="chat-filter-header-badge">
                ({{ unreadIncomingCount }})
              </span>
            </ion-button>
          </div>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <slot></slot>
        <ion-router-outlet></ion-router-outlet>

      </ion-content>
    </ion-page>
  </template>
  
  <script lang="ts" setup>
  import { IonPage, IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonContent, IonRouterOutlet, IonButton } from '@ionic/vue';
  import { useRoute } from 'vue-router';
  import { storeToRefs } from 'pinia';
  import { useChatMensajesUiStore } from '@/stores/chatMensajesUiStore';
  import tools from '@/composables/tools';

  const route = useRoute();
  const chatUi = useChatMensajesUiStore();
  const { showOnlyUnread, unreadIncomingCount } = storeToRefs(chatUi);

  const onToggleChatUnreadFilter = () => {
    if (!showOnlyUnread.value && unreadIncomingCount.value === 0) {
      void tools().toast('No hay mensajes sin leer', 'warning', 2800);
      return;
    }
    chatUi.toggleShowOnlyUnread();
  };
  </script>

<style scoped>
.chat-messages-subheader {
  --min-height: 44px;
  --padding-top: 0;
  --padding-bottom: 6px;
}

.chat-messages-subheader-inner {
  display: flex;
  align-items: center;
  padding-inline: 12px;
  padding-bottom: 4px;
}

.chat-filter-header-btn {
  margin: 0;
  --padding-start: 0.65rem;
  --padding-end: 0.65rem;
  font-size: 0.8rem;
}

.chat-filter-header-badge {
  margin-left: 0.15rem;
  font-weight: 600;
  opacity: 0.95;
}
</style>
  